module.exports = {"id":"198751","name":"José Antonio Madueña","rating":"71","photo":"./data/images/photos/2/198751.png","club":{"name":"Cruz Azul","logo":"./data/images/clubs/CruzAzul.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoseAntonioMaduena0.json
// module id = 2163
// module chunks = 0